import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { StatistikService } from '../../statistik.service';
import { TimeBudgetView } from '../../models/timebudgetView';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-statistik-kunde-plantid-modal',
    template: `<app-statistik-kunde-plantid-modal-ui
        [timebudgets]="timebudgets$ | async"
        [medID]="medID"
        [month]="month"
        [year]="year"
    ></app-statistik-kunde-plantid-modal-ui>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StatistikModalPlantidContainer implements OnInit {
    medID: number;
    month: number;
    year: number;
    date: Date;

    timebudgets$: Observable<TimeBudgetView[]>;

    constructor(
        private statistikService: StatistikService,
    ) { }

    ngOnInit(): void {
        this.date = this.convertYearMonthToDate(this.year, this.month);
        this.timebudgets$ = this.statistikService.getTimebudgetByMedId(this.year, this.month, this.medID);
    }

    convertYearMonthToDate(year: number, month: number): Date {
        const date = new Date();
        date.setFullYear(year, month - 1, 1);
        return date;
    }
}
